import { css } from "styled-components";
export const leagueClientSkin = (chroma) => css `
  && {
    all: unset;
    color: ${chroma.palette.borderGrey};
    background-color: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 25px;
    height: 25px;
    border: 2px solid ${chroma.palette.gold2};
    border-radius: 2px;
  }

  span.checkbox-indicator {
    margin: auto;

    .icon {
      display: block;
      background-color: ${chroma.palette.grey3};
    }
  }

  &:hover {
    background-color: ${chroma.palette.gold1};
    box-shadow: inset 0 0 3px 3px ${chroma.palette.goldGrey};

    .checkbox-indicator {
      .icon {
        background-color: ${chroma.palette.almostBlack};
      }
    }
  }

  &[data-state="checked"] {
    color: ${chroma.palette.goldGrey};
    background-color: ${chroma.palette.gold3};
  }
`;
//# sourceMappingURL=index.js.map